const MoreInfoButton = ({handleMoreInfoClick,className }) => { 

  return (
    <div className={`flex flex-col items-center justify-between mb-6 sm:flex-row ${className}`}> 
      <div className="flex justify-center gap-3 sm:justify-start"> 
        <button
          className="px-4 py-2 font-[500] md:text-base text-xs rounded-md text-[#0F172ACC] bg-white border border-gray-300 hover:bg-[#00811D1A] hover:text-[#000000]"
          onClick={() => handleMoreInfoClick('approved')}
        >
          Approve
        </button>
        <button
         className="px-4 py-2 font-[500] rounded-md md:text-base text-xs text-[#0F172ACC] bg-white border border-gray-300 hover:bg-[#00811D1A] hover:text-[#000000]"
          onClick={() => handleMoreInfoClick('rejected')}
        >
          Decline
        </button>
        <button
          className="px-4 py-2 font-[500] rounded-md md:text-base text-xs text-[#0F172ACC] bg-white border border-gray-300 hover:bg-[#00811D1A] hover:text-[#000000]"
          onClick={() => handleMoreInfoClick('more-info')}
        >
          More Info Required
        </button>
      </div>
    </div>
  )
}

export default MoreInfoButton
